<style scoped lang="scss">
// @import '~variables';
</style>
<template>
    <div>

        <h1 v-if="id">{{ id ? trans.get('collections.title_edit') : trans.get('collections.title_add') }}</h1>


        <div class="card">
            <div class="card-header">
                General
            </div>

            <div class="card-body">

                <form @submit.prevent="store" v-if="model">

                    <div class="form-group">
                        <label for="name">{{ trans.get('collections.name') }}</label>
                        <input type="text" class="form-control" id="name" v-model.trim="$v.model.name.$model">
                        <div class="invalid-feedback" v-has-error="'name'">
                            {{ trans.get('validation.required', {'attribute': trans.get('collections.name').toLowerCase() }) }}
                        </div>
                        <div class="form-text text-muted" v-if="model.id && !$v.model.name.$dirty">
                            <label>Slug: {{ model.slug }}</label>
                        </div>
                    </div>

                    <file-manager v-model="model.files" :isUploading.sync="isUploading" :id="model.id"></file-manager>

                    <div class="form-group">
                        <div class="alert alert-danger" v-has-error>
                            {{ trans.get('validation.invalid-form') }}
                        </div>
                        <a class="btn btn-secondary" v-if="back" :href="back" :disabled="isUploading" :class="{disabled: isUploading}">
                            {{ model.id ? trans.get('general.back') : trans.get('general.back') }}
                        </a>
                        <a class="btn btn-success" @click="store()" :disabled="isUploading" :class="{disabled: isUploading}">
                            {{ model.id ? trans.get('general.save') : trans.get('general.add') }}
                        </a>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';

    export default {
        props: {
            id: Number,
            back: String,
        },

        data() {
            return {
                isSubmitted: false,
                model: null,
                isUploading: false,
            };
        },

        validations: {
            model: {
                name: {
                    required,
                },
            }
        },

        created() {
            this.prepareComponent();
        },

        methods: {

            prepareComponent() {
                if (this.id) {
                    const loadPromise = (axios.get('/dynamic/collections/' + this.id))
                    .then(response => {
                        this.model = response.data;
                        this.model.files = this.model.files || [];
                    })
                    .catch(error => {
                        this.$toasted.global.appError({
                            message : this.trans.get('general.load_error') + error
                        });
                    });

                    this.$root.$once('pageSpinner', () => {
                        this.$root.pageSpinner.spin(loadPromise);
                    });
                } else {
                    this.model = {
                        name: '',
                        files: [],
                    };
                }
            },

            store() {

                this.isSubmitted = true

                if (!this.$v.model.$pending && !this.$v.model.$invalid && !this.isUploading) {

                    let promise;
                    const model = JSON.parse(JSON.stringify(this.model));
                    delete model.files;
                    const data = {
                        model: this.model,
                        file_ids: this.model.files.map(item => item.id)
                    };
                    if (this.model.id) {
                        promise = axios.put('/dynamic/collections/' + this.model.id, data);
                    } else {
                        promise = axios.post('/dynamic/collections', data);
                    }

                    this.$root.pageSpinner.spin(promise)
                    .then(response => {

                        this.model = response.data;
                        this.$v.$reset();
                        this.isSubmitted = false;

                        window.history.pushState('', '', '/collections/edit/' + this.model.id);

                        this.$toasted.global.appSuccess({
                            message : this.trans.get('general.save_success')
                        });
                    })
                    .catch(error => {
                        this.$toasted.global.appError({
                            message : this.trans.get('general.save_error') + error
                        });
                    });
                }
            },

        },

    }
</script>
